import styled from 'styled-components';
import { units } from '@m/alchemy-ui';

export const StyleAppIconSettings = styled.div`
  margin-top: ${units(1)};
`;